import { Button } from '@statsbomb/kitbag-components';
import { useVideoCurrentTime } from '@statsbomb/video-client-js';
import { useAtomValue } from 'jotai';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { styled } from 'styled-components';
import { currentPlaybackTimeAtom } from '../../../atoms/playback/playbackStatus';
import { microsecondsToTimeStamp } from '../../../utils/time';
import MetadataSelections from '../../MetadataSelections';

const TimestampContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-around;
`;

export function To({
  buttonTitle,
  compact,
  disabled,
  periodEnd,
  setPeriodEnd,
  size,
}) {
  const intl = useIntl();

  const deprecatedPlayerCurrentTime = useAtomValue(currentPlaybackTimeAtom);
  const vilPlayerCurrentTime = useVideoCurrentTime();
  const currentPlaybackTime =
    vilPlayerCurrentTime ?? deprecatedPlayerCurrentTime;

  const handleUseCurrentAsPeriodEnd = () => {
    setPeriodEnd(
      microsecondsToTimeStamp(currentPlaybackTime, { includeDecimals: true }),
    );
  };

  const time = microsecondsToTimeStamp(currentPlaybackTime);
  const currentPlaybackTimeDisplay = compact
    ? time
    : intl.formatMessage(
        { defaultMessage: 'Use {time}', id: '94f09' },
        {
          time,
        },
      );

  return (
    <TimestampContainer>
      <MetadataSelections.Timestamp
        disabled={disabled}
        label={intl.formatMessage({
          defaultMessage: 'Period End',
          id: 'bc6f8',
        })}
        labelPosition="top"
        setTimestamp={setPeriodEnd}
        size={size}
        timestamp={periodEnd}
      />
      {!disabled && (
        <Button
          isDisabled={disabled}
          onClick={handleUseCurrentAsPeriodEnd}
          size={size !== 'tiny' ? size : 'small'}
          title={intl.formatMessage(
            { defaultMessage: 'Period End {time}', id: '8a67f' },
            {
              time,
            },
          )}
          variant="secondary"
        >
          {buttonTitle || currentPlaybackTimeDisplay}
        </Button>
      )}
    </TimestampContainer>
  );
}

To.propTypes = {
  buttonTitle: PropTypes.string,
  compact: PropTypes.bool,
  disabled: PropTypes.bool.isRequired,
  periodEnd: PropTypes.number.isRequired,
  setPeriodEnd: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired,
};

To.defaultProps = {
  buttonTitle: undefined,
  compact: false,
};

export default { To };
